import axios from 'axios';

export const FETCH_SINGLE_USER_DATA_REQUEST = 'FETCH_SINGLE_USER_DATA_REQUEST';
export const FETCH_SINGLE_USER_DATA_SUCCESS = 'FETCH_SINGLE_USER_DATA_SUCCESS';
export const FETCH_SINGLE_USER_DATA_FAILURE = 'FETCH_SINGLE_USER_DATA_FAILURE';

export const fetchUsersDataRequest = () => ({
  type: FETCH_SINGLE_USER_DATA_REQUEST,
});

export const fetchUsersDataSuccess = (data) => ({
  type: FETCH_SINGLE_USER_DATA_SUCCESS,
  payload: data,
});

export const fetchUsersDataFailure = (error) => ({
  type: FETCH_SINGLE_USER_DATA_FAILURE,
  payload: error,
});


export const fetchSingleUser = (userId) => {
  console.log('User Id', userId);
  return async (dispatch) => {
    dispatch(fetchUsersDataRequest());
    try {
      const response = await axios.get(``);

      // console.log(response)

      dispatch(fetchUsersDataSuccess(response.data.users));
    } catch (error) {
      console.error('Error fetching users:', error);
      dispatch(fetchUsersDataFailure(error.message));
    }
  };
};
